import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BackResponse, BackResponseFailure } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/handling`;

export interface FileHandlingSpot {
  address?: string;
  zipCode?: string;
  city?: string;
  countryCode?: string;
}

export interface FileHandlingSummary {
  claimId: string;
  productLocationCountryCode?: string;
  productLocationZipCode?: string;
  hasDeposit: boolean;
  hasDelivery: boolean;
  hasHome: boolean;
  delivery?: FileHandlingSpot;
  deposit?: FileHandlingSpot;
  home?: FileHandlingSpot;
}

export interface GetFileHandlingRequestArgs {
  fileId: string;
}

export const getFileHandlingRequest = ({
  fileId,
}: GetFileHandlingRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getFileHandlingQuery = async (
  payload: GetFileHandlingRequestArgs,
): Promise<BackResponse<FileHandlingSummary> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<FileHandlingSummary>>(
      getFileHandlingRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
